var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.396,
    height: 77.396,
    viewBox: "0 0 77.396 77.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2663",
    transform: "translate(-1855 -413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1855 413)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2707",
    d: "M0,0H77.4V77.4H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2708",
    d: "M54.6,7.45H41.117a9.636,9.636,0,0,0-18.188,0H9.45A6.469,6.469,0,0,0,3,13.9V59.047A6.469,6.469,0,0,0,9.45,65.5H54.6a6.469,6.469,0,0,0,6.45-6.45V13.9A6.469,6.469,0,0,0,54.6,7.45Zm-22.574,0A3.225,3.225,0,1,1,28.8,10.674,3.234,3.234,0,0,1,32.023,7.45Z",
    transform: "translate(6.674 2.225)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1870.638 428.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rechteck 5118",
    width: 45,
    height: 45,
    transform: "translate(0.362 0.416)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    "data-name": "Pfad 2706",
    d: "M15.942,35.867h23.9a2,2,0,0,0,1.992-1.992V5.992A2,2,0,0,0,39.842,4h-23.9A2,2,0,0,0,13.95,5.992V33.875A2,2,0,0,0,15.942,35.867Zm-7.967-23.9H3.992A2,2,0,0,1,2,9.975V5.992A2,2,0,0,1,3.992,4H7.975A2,2,0,0,1,9.967,5.992V9.975A2,2,0,0,1,7.975,11.967Zm0,23.9H3.992A2,2,0,0,1,2,33.875V29.892A2,2,0,0,1,3.992,27.9H7.975a2,2,0,0,1,1.992,1.992v3.983A2,2,0,0,1,7.975,35.867Zm0-11.95H3.992A2,2,0,0,1,2,21.925V17.942A2,2,0,0,1,3.992,15.95H7.975a2,2,0,0,1,1.992,1.992v3.983A2,2,0,0,1,7.975,23.917Z",
    transform: "translate(1.144 2.785)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderListIcon);
export default __webpack_public_path__ + "static/media/orderListIcon.a7b00255.svg";
export { ForwardRef as ReactComponent };